import { useState, useEffect } from 'react';
import arrow from "assets/img/Arrow.svg";

function Download() {
  const [text, setText] = useState("");
  const [url1, setURL1] = useState("");
  const [url2, setURL2] = useState("");
  const [ver1, setVer1] = useState("");
  const [ver2, setVer2] = useState("");
  const [urlg, setURLg] = useState("");
  
  const yaml = require('js-yaml');
  const domain = 'https://cdn.aukabucom.fx.ever.gs/';

  useEffect(() => {
    var ua = window.navigator.userAgent.toLowerCase();
    if(ua.indexOf("mac os x") !== -1) {
        setText("MacOS");

        const ymlFile = 'latest-mac.yml';
        const pathM = 'app/mac/';
        var xhrM = new XMLHttpRequest();
        xhrM.open("GET", domain + pathM + ymlFile, true);
        xhrM.send(null);
        xhrM.onload = function(){
            var dataM = yaml.load(xhrM.responseText);
            var fileM = domain + pathM + "Mitsubishi-UFJ-eSmart-Securities-FX-1.0.0.dmg";
            for (let i = 0; i < dataM.files.length; i++) {
                if (dataM.files[i].url.toLocaleLowerCase().includes(".dmg")) {
                    fileM = domain + pathM + dataM.files[i].url;
                    break;
                }
            }
            setURL1(fileM);  
            setVer1(dataM.version || "1.0.0");
            setURLg(domain + "manual/")
        };
    } else {
        if(ua.indexOf("windows nt") !== -1) {
            setText("WinOS");
        } else {
            setText("Other");
        }

        const ymlFile = 'latest.yml';

        const path32 = 'app/win32/';
        var xhr32 = new XMLHttpRequest();
        xhr32.open("GET", domain + path32 + ymlFile, true);
        xhr32.send(null);
        xhr32.onload = function(){
            var data32 = yaml.load(xhr32.responseText);
            var file32 = domain + path32 + "Mitsubishi-UFJ-eSmart-Securities-FX-WIN32-Setup-1.0.0.exe";
            for (let i = 0; i < data32.files.length; i++) {
                if (data32.files[i].url.toLocaleLowerCase().includes(".exe")) {
                    file32 = domain + path32 + data32.files[i].url;
                    break;
                }
            }
            setURL1(file32);  
            setVer1(data32.version || "1.0.0");
            setURLg(domain + "manual/")
        };
    
        const path64 = 'app/win64/';
        var xhr64 = new XMLHttpRequest();
        xhr64.open("GET", domain + path64 + ymlFile, true);
        xhr64.send(null);
        xhr64.onload = function(){
            var data64 = yaml.load(xhr64.responseText);
            var file64 = domain + path64 + "Mitsubishi-UFJ-eSmart-Securities-FX-Setup-1.0.0.exe";
            for (let i = 0; i < data64.files.length; i++) {
                if (data64.files[i].url.toLocaleLowerCase().includes(".exe")) {
                    file64 = domain + path64 + data64.files[i].url;
                    break;
                }
            }
            setURL2(file64);  
            setVer2(data64.version || "1.0.0");
        };
    }
  });　

  return (
    <div className="body-container">
        <div className="content-container">
            <div className="message-container">
                <div className="msg-containter">
                    <div className="msg-ever-fx m-t-0">
                        「三菱UFJ eスマート証券 FX」のPCアプリはインストールが必要になります。
                        <br />
                        お手数ですが、以下よりダウンロードをお願いいたします。
                    </div>
                </div>

{ text === "MacOS" ? // OS： Mac OS                
                <div id="download-containter">
                    <a className="btn-download m-t-26" href={url1}>
                        <div className="lb-download">
                            ダウンロード
                            <br/>
                            <div className="lb-version">
                                バージョン {ver1}
                            </div>
                        </div>
                    </a>
                    <div className="link-mac">
                        <img src={ arrow } className='arrow-ico'/>
                        <div>操作ガイドは</div>
                        <a className="note-refer-link" target="_blank" href={urlg} rel="noopener noreferrer">こちら</a>
                    </div>
                </div>
://text === "winOS" ?// OS： Windows（Mac以外）
                <div id="download-containter">
                    <div className="window-btn-download-ctn">
                        <a className="btn-download-windows m-t-25" href={url2}>
                            <div className="lb-download">
                                ダウンロード
                                <br/>
                                <div className="lb-version">
                                    バージョン {ver2}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="link-win">
                        <img src={ arrow } className='arrow-ico'/>
                        <div>操作ガイドは</div>
                        <a className="note-refer-link" target="_blank" href={urlg} rel="noopener noreferrer">こちら</a>
                    </div>
                </div>
}
            </div>
        </div>
    </div>
  );
}

export default Download;
